import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import externalApi from '../../api';

type EditTrackedEquipmentServiceRequest = {
  trackedEquipmentServiceId: string;
  notes: string;
  lastUpdatedUserId: string;
};

type EditTrackedEquipmentServiceResponse = {
  trackedEquipmentServiceId: number;
};

function editTrackedEquipmentService(
  request: EditTrackedEquipmentServiceRequest
): Promise<EditTrackedEquipmentServiceResponse> {
  return externalApi.patch(`TrackedEquipmentService/patch/notes`, { json: request }).json();
}

function useEditTrackedEquipmentServiceNotes() {
  const queryClient = useQueryClient();
  return useMutation(
    (request: EditTrackedEquipmentServiceRequest) => editTrackedEquipmentService(request),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['AllTrackedEquipmentService']);
      },
    }
  );
}
export { useEditTrackedEquipmentServiceNotes };
